import React from "react";

const ManageIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21.525"
      height="21.53"
      viewBox="0 0 21.525 21.53"
    >
      <g
        id="Manage_Apps"
        data-name="Manage Apps"
        transform="translate(-11.24 -11.235)"
      >
        <path
          id="Path_1147"
          data-name="Path 1147"
          d="M21.308,12.013V20.53a.778.778,0,0,1-.778.778H12.018a.778.778,0,0,1-.778-.778V12.013a.778.778,0,0,1,.778-.778H20.53A.778.778,0,0,1,21.308,12.013ZM20.53,22.7H12.018a.778.778,0,0,0-.778.778v8.513a.778.778,0,0,0,.778.778H20.53a.778.778,0,0,0,.778-.778V23.475A.778.778,0,0,0,20.53,22.7Zm11.457,0H23.475a.778.778,0,0,0-.778.778v8.513a.778.778,0,0,0,.778.778h8.513a.778.778,0,0,0,.778-.778V23.475a.778.778,0,0,0-.778-.778Zm-8.575-7.927.726-1.327c.3-.073.964-.14,1.166.073l1.094-.669c-.1-.275.275-.84.472-1.068l1.514-.036c.213.223.607.767.518,1.047l1.13.617c.187-.223.861-.187,1.161-.124l.788,1.291c-.088.29-.363.907-.648.975l.026,1.281c.29.052.6.653.695.944L31.329,19.1c-.3.073-.969.14-1.166-.073l-1.1.669c.1.275-.27.84-.472,1.068l-1.509.036c-.213-.223-.607-.767-.524-1.047l-1.125-.617c-.192.223-.861.187-1.166.13l-.783-1.291c.088-.3.363-.912.648-.98L24.1,15.714C23.817,15.662,23.511,15.061,23.413,14.771Zm3.676,2.68a1.343,1.343,0,1,0-.649-.8A1.344,1.344,0,0,0,27.088,17.451Z"
          transform="translate(0 0)"
          fill={fill ? fill : "#000"}
        />
      </g>
    </svg>
  );
};

export default ManageIcon;
